module.exports = __webpack_public_path__ + "static/ipad-5ac0df1f7985e39cf1fb800d44bc7eef.png";